import React,{useState,useEffect} from 'react'
import { useTranslation } from 'react-i18next';
// import validator from "validator";
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch, Menu, TreeSelect,
} from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import Parameters from 'shared/parameters';
import arrowLeft from '../../../src/img/arrow-left.png';
import addCat from '../../../src/img/add-category.png';
import stars from '../../../src/img/stars.png';
import openBook from '../../../src/img/open-book.png';
import imgIcon from '../../../src/img/image-icon.png';
import video from '../../../src/img/video.png';
import stepCircle from '../../../src/img/step-circle.png';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
interface Props{
    nextStep:any,
    handleCatData:any,
    values:any,
    draftCatVal:any,
    catVal:any
}
interface hideHeader {
    hideHeader?: boolean;
  }
// const RouteParams: any = useParams();
// const [saving, setSaving] = useState(false);
// const [uploading, setUploading] = useState(false);

const { Option, OptGroup } = Select; 

function CourseCategory(props:Props,hideHeader:hideHeader ) { 
     
    //creating error state for validation
    const { nextStep, handleCatData, values,draftCatVal,catVal } = props
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);
  const { t } = useTranslation();
  const history: any = useHistory();
  const RouteParams: any = useParams();
  const [categories, setCategories] = useState([] as any[]);
  const [form] = Form.useForm();
  const [lang, setLang] = useState('' as any);
  const refreshMetaData = async () => {
    try {
        if(Parameters.Mode !== 'CLIENT'){
          const {
            data: { data: c },
          } = await API_SERVICE.fetchSubCategoryAdmin({ per_page: 1000 });
          setCategories(c);
          console.log('cccccc',c)
        }else{
          const {
            data: { data: c },
          } = await API_SERVICE.fetchSubCategoriesCourses({ per_page: 1000});
          setCategories(c);
        }

    } catch (e) {
        notification.error({
            message: t(API_SERVICE.handleErrors(e)),
        });
    }
};

const [value, setValue] = useState<string>();

  const onChange = (newValue: string) => {
    console.log(newValue);
    setValue(newValue);
    handleCatData(newValue)
  };
useEffect(() => {
    refreshMetaData();
    setLang(localStorage.getItem('language'));
}, []);
useEffect(() => {
    handleCatData(draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '')
    form.setFieldsValue({
        'category_id': draftCatVal && draftCatVal!= null || draftCatVal!= '' ? draftCatVal : catVal && catVal != null || catVal != "" ? catVal : '',
    });
}, [draftCatVal,catVal]);
    const saveDraftData = () => {
        setSaving(true);
        let form_vals = form.getFieldsValue();
        // let localData = JSON.parse(localStorage.getItem("auth-token") || "")
        // console.log('localData',localData)
        // return
        console.log('draft saved value',form_vals)
        if(Parameters.Mode !== 'CLIENT'){
            API_SERVICE.createDraftCourseAdmin(form_vals).then((d) => {
                setSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setSaving(false);
            });
        }else {
            API_SERVICE.createDraftCourseInstructor(form_vals).then((d) => {
                setSaving(false);
                history.goBack();
            }).catch((e) => {
                notification.error({ message: API_SERVICE.handleErrors(e) });
                setSaving(false);
            });
        }
    }
    // function SubCat({ items } : any) {
    //     let i = 10;
    //     return  (<>
    //         {items.map((item : any,index : any) => {
    //             return <>
    //                     {item.children_count === 0 ?  
    //                         item.disabled = false
    //                     :
    //                         item.disabled = true
    //                     }
    //                     {item.children_count !== 0 && <SubCat items={item.children} /> }
    //                     </>
    //         })}
    //     </>)
            
    // }
  // after form submit validating the form data using validator
  const submitFormData = () => {
    nextStep();

    // checking if value of first name and last name is empty show error else take to step 2
    // if (
    //   props.values.courseCategory !== "" ||
    //   props.values.courseCategoryType !== ""
    // ) {
    //   setError(true);
    // } else {
    //   props.nextStep();
    // }
  };     
        return (
            <>
                <div className={hideHeader.hideHeader ? '' : ''}>
                {/* {categories.length !== 0 && <>
                    <SubCat items={categories} />
                    {console.log("modified cat obj", categories)}
                </> } */}
                    <div className='d-md-flex'>
                        <FrontendSidebar menuSelect={2} />
                        
                        <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3': 'mb-3'} style={{width: '100%'}}>
                        {
                        !hideHeader.hideHeader && <>
                            
                            <div className="container-fluid">
                                <div className='row'>
                                    {/* <div className='col-sm-12 mt-3'> */}
                                    <div className={lang == 'ar' ? 'row text-right mt-3 ml-2' : 'col-sm-12 mt-3'}>
                                        <h3><span className='back-bg mr-4 cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span> {RouteParams['mode'] === 'create' ? t('course.create') : ''}</h3>    
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="container-fluid">
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                        <div className="col-md-12 pt-3 pb-3">
                                            <div className="steps">
                                                <ul id="progressbar" className="list-style-none w-100 d-flex">
                                                <li className="w-100 steps-li">
                                                    <div className="progress">
                                                        <div className="progress-bar w-100"></div>
                                                    </div>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                            <span className="icon-bg"><img src={addCat}/></span>
                                                            <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                        </div>
                                                        <div className={lang == 'ar' ? 'text-right ml-2' : 'mr-4'}>
                                                            <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5"> {t('genDict.Step1')}</p>
                                                            <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.SelectCreateACategory')}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="w-100 steps-li">
                                                    <div className="progress">
                                                        <div className="progress-bar"></div>
                                                    </div>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                            <span className="icon-bg star"><img src={stars} style={{width:'29px'}}/></span>
                                                            <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                        </div>
                                                        <div className={lang == 'ar' ? 'text-right ml-2' : 'mr-4'}>
                                                            <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step2')}</p>
                                                            <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.Select_SelectLevel')}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="w-100 steps-li">
                                                    <div className="progress">
                                                        <div className="progress-bar"></div>
                                                    </div>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                            <span className="icon-bg video"><img src={video}/></span>
                                                            <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                        </div>
                                                        <div className={lang == 'ar' ? 'text-right ml-2' : 'mr-4'}>
                                                            <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step3')}</p>
                                                            <p className="mb-0 text-uppercase small font-InterMedium">{t('genDict.CreateCourse')}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="w-100 steps-li">
                                                    <div className="progress">
                                                        <div className="progress-bar"></div>
                                                    </div>
                                                    <div className="d-flex align-items-center mt-2">
                                                        <div className={lang == 'ar' ? 'text-right' : 'mr-3'}>
                                                            <span className="icon-bg open-book"><img src={openBook}/></span>
                                                            <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                                        </div>
                                                        <div className={lang == 'ar' ? 'text-right ml-2' : 'mr-4'}>
                                                            <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">{t('genDict.Step4')}</p>
                                                            <p className="mb-0 text-uppercase font-InterMedium small font-InterMedium">{t('genDict.Add_Content')}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                                </ul>
                                            </div>
                                            <div className="form-fields pl-4 pr-6rem">
                                                <Form 
                                                    form={form}
                                                    size='large' 
                                                    layout='vertical'
                                                    requiredMark={true} 
                                                    onFinish={submitFormData}
                                                >
                                                    <fieldset>
                                                    
                                                        {/* <div className="row"> */}
                                                        <div className={lang == 'ar' ? 'row text-right' : 'row'}>
                                                            <div className="col-md-5 mt-5">
                                                                <h5>{t('genDict.selectCategory')}</h5>
                                                                <p className="text-secondary">{t('genDict.selectCategoryParagraph')}</p>
                                                            </div>
                                                            <div className="col-md-7 mt-5">
                            
                                                                {/* <Form.Item
                                                                    label={t('course.category.label')}
                                                                    initialValue = {values.courseCategory}
                                                                    name={'category_id'}
                                                                    rules={[
                                                                        { required: true, message: t('course.category.required') },
                                                                    ]}>
                                                                    <select onChange={handleFormData('courseCategory')}>
                                                                        {
                                                                            categories.map((level: any) => {
                                                                                return <option value={level.id}>{level.name}</option>;
                                                                            })
                                                                        }
                                                                    </select>
                                                                </Form.Item> */}
                                                                {console.log('catVal',catVal, typeof catVal)
                                                                }
                                                                {console.log("draftCat",draftCatVal,typeof draftCatVal)}
                                                                <Form.Item
                                                                    label={t('course.category.label')}
                                                                    // initialValue = { catVal && catVal != null || catVal != "" ? catVal : draftCatVal && draftCatVal != null || draftCatVal != "" ? console.log('initial value draft',draftCatVal) : ''}
                                                                    name={'category_id'}
                                                                    rules={[
                                                                        { required: true, message: t('course.category.required') },
                                                                    ]}>
                                                                    {/* <select className='form-control' onChange={handleFormData('category_id')}>
                                                                        <option value={''} selected>{t('category.choose')}</option> */}
                                                                        {/* {
                                                                            categories.map((level: any) => {
                                                                                return <option value={level.id}>{level.name}</option>;
                                                                            })
                                                                        } */}
                                                                        {/* <SubCat catItems={categories} /> */}
                                                                        {/* <SubCat items={categories} /> */}
                                                                        <TreeSelect
                                                                            showSearch
                                                                            treeNodeFilterProp='title'
                                                                            style={{ width: '100%' }}
                                                                            value={value}
                                                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                                            placeholder="Please select"
                                                                            allowClear
                                                                            treeDefaultExpandAll={false}
                                                                            onChange={onChange}
                                                                            treeData={categories}
                                                                        />
                                                                    {/* </select> */}
                                                                </Form.Item>
                                                                <p className='mb-0'>{t('genDict.Or')}<br/>
                                                                    <a onClick={() => history.push('/categories/create')} role="button" className='text-blue'><u>{t('genDict.addnewcategory')}</u></a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <hr>
                                                        </hr>
                                                        {/* <div className="row">
                                                            <div className="col-md-5 mt-4">
                                                                <h5>Create a New Category</h5>
                                                                <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                                            </div>
                                                            <div className="col-md-7 mt-4">
                                                                <div className="form-group">
                                                                    <div className="d-flex align-items-center">
                                                                    <div className="mr-2">
                                                                        <img src={imgIcon} className="img-cat"/>
                                                                        <img src={addCat} id="uploadedImage" className="uploaded-img-cat" height="48" width="48" style={{display:'none'}}/>
                                                                    </div>
                                                                    <div>
                                                                        <input type="file" name="cat-img" id="cat-img" className="d-none" accept="image/*"/>
                                                                        <button type="button" className="btn btn-default cat-img-upload">Change</button>
                                                                    </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label className="text-secondary">Name of the Category</label>
                                                                    <input type="text" name="cat-name" id="cat-name" className="form-control"/>
                                                                    </div>
                                                                <div className='form-group'>
                                                                    <label className="text-secondary">Name of the Category DE</label>
                                                                    <input type="text" name="cat-name" id="cat-name" placeholder='DE' className="form-control"/>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label className="text-secondary">Description (Optional)</label>
                                                                    <textarea className="form-control" name="cat-desc" id="cat-desc" rows={5}></textarea>
                                                                </div>
                                                                <div className='form-group'>
                                                                    <label className="text-secondary">Description DE (Optional)</label>
                                                                    <textarea className="form-control" name="cat-desc" id="cat-desc" rows={5}>DE</textarea>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                        <hr>
                                                        </hr>*/}
                                                        {
                                                            <Form.Item className='float-right' style={{width:'max-content'}}>
                                                                <Button
                                                                    htmlType="submit"
                                                                    shape="round"
                                                                    size={'large'}
                                                                    className='btn btn-blue'
                                                                >
                                                                    {t('genDict.saveAndContinue')}
                                                                </Button>
                                                            </Form.Item>
                                                        }
                                                        {
                                                            <Form.Item className='float-right mr-3' style={{width:'max-content'}}>
                                                                <Button
                                                                    // htmlType="submit"
                                                                    shape="round"
                                                                    size={'large'}
                                                                    className='btn btn-default'
                                                                    loading={saving}
                                                                    disabled={catVal && catVal != null && catVal != '' ? true : false}
                                                                    onClick={saveDraftData}
                                                                >
                                                                    {t('genDict.SaveCategoryandExit')}
                                                                </Button>
                                                            </Form.Item>
                                                        }
                                                    </fieldset>
                                                </Form>

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
            
            </>
        )
}
export default CourseCategory